import {flashcard} from './Flashcard';

export const otherFeatures = {
  flashcard,
};
